import React from 'react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { buttonClasses } from '../../components/ui/Button';
import { MatchReason } from '../../components/MatchReason';
import { ClipboardList, Layers, ArrowRight, TrendingUp, Clock, Zap, Users } from 'lucide-react';
import { useMaintenance } from '../../context/MaintenanceContext';
const jobStatusLabel: Record<string, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManDashboardPage() {
  const {
    jobs,
    opportunities,
    requests,
    openAggregations
  } = useMaintenance();
  const daAccettare = jobs.filter(j => j.status === 'da_accettare');
  const oggi = jobs.filter(j => j.date === 'Oggi');
  const urgentRequests = requests.filter(r => r.urgency === 'urgente' && r.status === 'in_ricerca');
  const ownAggregating = requests.filter(r => r.status === 'in_attesa_aggregazione');
  const aggregationsCount = openAggregations.length + ownAggregating.length;
  const highlight = opportunities[0];
  const stats = [{
    label: 'Interventi urgenti',
    value: `${urgentRequests.length}`,
    to: '/man/opportunita'
  }, {
    label: 'Raggruppamenti',
    value: `${aggregationsCount}`,
    to: '/man/opportunita'
  }, {
    label: 'Incarichi oggi',
    value: `${oggi.length}`,
    to: '/man/incarichi'
  }, {
    label: 'Da accettare',
    value: `${daAccettare.length}`,
    to: '/man/incarichi'
  }];
  return <MobileLayout data-id="element-2850">
      <div className="mb-6" data-id="element-2851">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2852">
          Ciao, Manutentore 👋
        </h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-id="element-2853">
        {stats.map(s => <Link key={s.label} to={s.to} className="bg-white border border-border rounded-xl p-4 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-2854">
            <div className="text-2xl font-bold text-foreground" data-id="element-2855">{s.value}</div>
            <div className="text-xs text-muted-foreground mt-1" data-id="element-2856">{s.label}</div>
          </Link>)}
      </div>

      {/* Highlight Card */}
      {urgentRequests.length > 0 ? <Link to="/man/opportunita" className="flex items-center gap-3 bg-white border border-border rounded-xl px-4 py-3.5 mb-6 hover:border-coral/50 hover:shadow-sm transition-all min-h-[44px]" data-id="element-2857">
          <span className="w-8 h-8 rounded-lg bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-2858">
            <Zap size={16} className="text-coral" data-id="element-2859" />
          </span>
          <span className="text-sm text-foreground min-w-0" data-id="element-2860">
            <span className="font-semibold text-navy" data-id="element-2861">
              {urgentRequests.length}
            </span>{' '}
            {urgentRequests.length === 1 ? 'intervento urgente' : 'interventi urgenti'}{' '}
            da assegnare
          </span>
          <Badge tone="coral" className="hidden sm:inline-flex flex-shrink-0" data-id="element-2862">
            URGENTE
          </Badge>
          <span className="ml-auto inline-flex items-center gap-1 text-sm font-medium text-coral flex-shrink-0" data-id="element-2863">
            Vedi tutte
            <ArrowRight size={15} data-id="element-2864" />
          </span>
        </Link> : aggregationsCount > 0 ? <Link to="/man/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-teal-deep/50 hover:shadow-sm transition-all" data-id="element-2865">
          <div className="flex items-start gap-4" data-id="element-2866">
            <div className="w-12 h-12 rounded-xl bg-teal-deep/10 flex items-center justify-center flex-shrink-0" data-id="element-2867">
              <Users size={24} className="text-teal-deep" data-id="element-2868" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-2869">
              <h2 className="text-sm font-semibold text-foreground mb-1" data-id="element-2870">
                {aggregationsCount}{' '}
                {aggregationsCount === 1 ? 'raggruppamento' : 'raggruppamenti'}{' '}
                in zona
              </h2>
              <p className="text-xs text-muted-foreground" data-id="element-2871">
                Gruppi di interventi in formazione: candidati per servirli
                insieme e ottimizzare gli spostamenti.
              </p>
              <div className="flex items-center gap-1 text-sm font-medium text-teal-deep mt-2" data-id="element-2872">
                Vedi raggruppamenti
                <ArrowRight size={15} data-id="element-2873" />
              </div>
            </div>
          </div>
        </Link> : highlight ? <Link to="/man/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-2874">
          <div className="flex items-start gap-4" data-id="element-2875">
            <div className="w-12 h-12 rounded-xl bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-2876">
              <Layers size={24} className="text-coral" data-id="element-2877" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-2878">
              <div className="flex items-center gap-2 mb-1" data-id="element-2879">
                <h2 className="text-sm font-semibold text-foreground" data-id="element-2880">
                  {highlight.jobsCount} interventi {highlight.trade}{' '}
                  raggruppabili
                </h2>
                <span className="text-[10px] font-medium text-coral bg-coral/10 px-1.5 py-0.5 rounded-full" data-id="element-2881">
                  NUOVO
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-1.5" data-id="element-2882">
                {highlight.zone} · {highlight.window}
              </p>
              <MatchReason distanceKm={highlight.distanceKm} efficiency={highlight.efficiency} peopleInZone={highlight.hostsInZone} peopleLabel="host in zona" data-id="element-2883" />
              <div className="flex items-center gap-1 text-sm font-medium text-coral mt-2" data-id="element-2884">
                Vedi opportunità
                <ArrowRight size={15} data-id="element-2885" />
              </div>
            </div>
          </div>
        </Link> : null}

      <Card className="mb-6" data-id="element-2886">
        <CardHeader icon={<ClipboardList size={15} className="text-muted-foreground" data-id="element-2888" />} title="Incarichi di oggi" action={<Link to="/man/incarichi" className="text-xs font-medium text-coral hover:underline" data-id="element-2889">
              Vedi tutti
            </Link>} data-id="element-2887" />
        <CardContent data-id="element-2890">
          {oggi.length === 0 && <p className="text-sm text-muted-foreground text-center py-4" data-id="element-2891">
              Nessun incarico per oggi.
            </p>}
          <ul className="space-y-3" data-id="element-2892">
            {oggi.map(j => <li key={j.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-2893">
                <div className="min-w-0" data-id="element-2894">
                  <div className="text-sm font-semibold text-foreground truncate" data-id="element-2895">
                    {j.title}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5" data-id="element-2896">
                    <Clock size={12} data-id="element-2897" />
                    {j.time}
                    <span data-id="element-2898">·</span>
                    {j.zone}
                  </div>
                </div>
                <span className={`text-[10px] font-medium px-2 py-1 rounded-full border flex-shrink-0 ${jobStatusLabel[j.status].cls}`} data-id="element-2899">
                  {jobStatusLabel[j.status].label}
                </span>
              </li>)}
          </ul>
        </CardContent>
      </Card>

      <Link to="/man/guadagni" className="block bg-white border border-border rounded-xl p-5 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-2900">
        <div className="flex items-center justify-between" data-id="element-2901">
          <div className="flex items-center gap-3" data-id="element-2902">
            <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-2903">
              <TrendingUp size={20} className="text-navy" data-id="element-2904" />
            </div>
            <div data-id="element-2905">
              <div className="text-sm font-semibold text-foreground" data-id="element-2906">
                Guadagni stimati questo mese
              </div>
              <div className="text-xs text-muted-foreground" data-id="element-2907">
                Su interventi confermati e completati
              </div>
            </div>
          </div>
          <div className="text-lg font-bold text-coral" data-id="element-2908">€1.240</div>
        </div>
      </Link>
    </MobileLayout>;
}